import { useState, useEffect } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminRefunds() {
  const [refunds, setRefunds] = useState([]);
  const load = () => api.get("/admin/refunds").then((r) => setRefunds(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    await api.put(`/admin/refunds/${id}`, { action });
    toast.success(action === "approve" ? "Refund approved — access revoked" : "Refund denied");
    load();
  };

  const statusColor = { pending: "text-[var(--forge-gold)]", approved: "text-[var(--forge-green)]", denied: "text-red-400" };

  return (
    <div>
      <h1 className="font-display font-bold text-xl mb-6" data-testid="admin-refunds-title">REFUND QUEUE</h1>
      <div className="space-y-2">
        {refunds.length === 0 && <p className="text-sm text-[var(--forge-dim)]" data-testid="no-refunds">No refund requests.</p>}
        {refunds.map((r) => (
          <div key={r.id} className="forge-card !transform-none p-4" data-testid={`admin-refund-${r.id}`}>
            <div className="flex flex-wrap items-center gap-3">
              <div className="flex-1 min-w-[200px]">
                <p className="text-sm font-medium">{r.course_title}</p>
                <p className="text-xs text-[var(--forge-dim)]">{r.user_name} ({r.user_email}) · {new Date(r.created_at).toLocaleDateString()}</p>
                {r.reason && <p className="text-xs text-[var(--forge-dim)] mt-1 italic">"{r.reason}"</p>}
              </div>
              <div className="text-right">
                <p className={`text-sm font-display ${r.watch_pct >= 20 ? "text-[var(--forge-gold)]" : "text-[var(--forge-green)]"}`} data-testid={`refund-watch-pct-${r.id}`}>{r.watch_pct}% watched</p>
                {r.auto_flagged && <p className="text-[10px] text-[var(--forge-gold)]">⚠ AUTO-FLAGGED (≥20%)</p>}
              </div>
              {r.status === "pending" ? (
                <div className="flex gap-2">
                  <button data-testid={`approve-refund-${r.id}`} onClick={() => act(r.id, "approve")} className="text-xs font-display px-3 py-1.5 rounded border border-[var(--forge-green)] text-[var(--forge-green)] hover:bg-[rgba(74,222,128,0.1)]">APPROVE</button>
                  <button data-testid={`deny-refund-${r.id}`} onClick={() => act(r.id, "deny")} className="text-xs font-display px-3 py-1.5 rounded border border-red-400 text-red-400 hover:bg-[rgba(248,113,113,0.1)]">DENY</button>
                </div>
              ) : (
                <span className={`font-display uppercase text-xs ${statusColor[r.status]}`}>{r.status}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
